import { createClient } from '@supabase/supabase-js'

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || 'https://msyfgnuisdtvzlpwfqgi.supabase.co'
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im1zeWZnbnVpc2R0dnpscHdmcWdpIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTAwMjMxNjUsImV4cCI6MjA2NTU5OTE2NX0.7BWoOUYVy--p4MLtFAOs0uS76kV2i7R3KHi0ZHZkqLU'

export const supabase = createClient(supabaseUrl, supabaseAnonKey)